import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as semver from "semver";
import Banner from "../../controls/Banner";
import DynDiv from "../../controls/DynDiv";
import FlexLayout from "../../controls/FlexLayout";
import Icon from "../../controls/Icon";
import IconBar from "../../controls/IconBar";
import { useSwitchingProfile } from "../../hooks";
import { NotificationButton } from "../NotificationButton";
import { QuickLauncher } from "../QuickLauncher";
// Looks like we never really used them?
// I haven't found any way to inject here anything
const applicationButtons = [];
const globalButtons = [];
export const Toolbar = () => {
    const { t } = useTranslation();
    const customTitlebar = useSelector((state) => state.settings.window.customTitlebar);
    const version = useSelector((state) => state.app.appVersion);
    const switchingProfile = useSwitchingProfile();
    const parsedVersion = semver.parse(version);
    const prerelease = parsedVersion?.prerelease[0] ?? "stable";
    const updateChannelClassName = "toolbar-version-container toolbar-version-" + prerelease;
    const className = customTitlebar ? "toolbar-app-region" : "toolbar-default";
    // Filter out modernOnly actions (Classic UI should only show classicOnly or neutral actions)
    const filterGlobalIcons = useCallback((action) => !action.options?.isModernOnly, []);
    if (switchingProfile) {
        return React.createElement("div", { className: className });
    }
    return (React.createElement(FlexLayout.Fixed, { className: className, id: "main-toolbar" },
        React.createElement(QuickLauncher, null),
        React.createElement(Banner, { group: "main-toolbar" }),
        React.createElement(DynDiv, { group: "main-toolbar" }),
        React.createElement("div", { className: "flex-fill" }),
        React.createElement("div", { className: "main-toolbar-right" },
            React.createElement("div", { className: "toolbar-version" },
                process.env.IS_PREVIEW_BUILD === "true" ? (React.createElement("div", { className: "toolbar-version-container toolbar-version-staging" },
                    React.createElement(Icon, { name: "conflict" }),
                    React.createElement("div", { className: "toolbar-version-text" }, "Staging"))) : null,
                process.env.NODE_ENV === "development" ? (React.createElement("div", { className: "toolbar-version-container toolbar-version-dev" },
                    React.createElement(Icon, { name: "mods" }),
                    React.createElement("div", { className: "toolbar-version-text" }, "Development"))) : null,
                React.createElement("div", { className: updateChannelClassName },
                    prerelease !== "stable" ? React.createElement(Icon, { name: "highlight-lab" }) : null,
                    React.createElement("div", { className: "toolbar-version-text" }, version))),
            React.createElement("div", { className: "application-icons-group" },
                React.createElement(IconBar, { className: "application-icons", group: "application-icons", staticElements: applicationButtons, t: t }),
                React.createElement(NotificationButton, { hide: switchingProfile, id: "notification-button" }),
                React.createElement(IconBar, { className: "global-icons", collapse: true, filter: filterGlobalIcons, group: "global-icons", id: "global-icons", orientation: "vertical", staticElements: globalButtons, t: t })))));
};
